import React from 'react';
import { useDrop } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
// const style = {
//     height: '12rem',
//     width: '12rem',
//     marginRight: '1.5rem',
//     marginBottom: '1.5rem',
//     color: 'white',
//     padding: '1rem',
//     textAlign: 'center',
//     fontSize: '1rem',
//     lineHeight: 'normal',
//     float: 'left',#
// };
function Dustbin(props) {

    var whereToInsert = props.whereToInsert;
    var insertPosition = props.insertPosition;
    var dustbinText = props.dustbinText;

    const [{ canDrop, isOver }, drop] = useDrop({
        accept: ItemTypes.BOX,
        drop: () => ({ name: 'Dustbin', whereToInsert, insertPosition }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    const isActive = canDrop && isOver;
    // let backgroundColor = '#222';

    var style = {
        width: '100%',
        textAlign: 'center',
    };

    var text = null;
    if (isActive){
        text = "Release to Drop";
        style.backgroundColor = "#FFEDD9";
        if (dustbinText){
            style.padding = "10px";            
        }
    }else{
        text = dustbinText;
        if (text){
            style.color = "#CCC";
            style.padding = "10px";
        }else{
            if (insertPosition === 0 || insertPosition === -1){
                style.height = "10px";
            }else{
                style.height = "2px";
            }
        }
    }

    return (<div ref={drop} style={style}>
            {text}
        </div>);
};


export default Dustbin;